var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_1052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02178 23.1109C5.39151 22.9055 2.50096 19.8872 2.50096 16.2061C2.50096 12.3925 5.60334 9.28985 9.41665 9.28985C11.1221 9.28985 12.7598 9.91564 14.028 11.0519C15.4926 12.362 16.3329 14.2408 16.3329 16.2061C16.3329 17.8543 15.7416 19.4414 14.6867 20.6837C15.4349 21.1685 16.2938 21.4581 17.189 21.5241C18.2663 19.9558 18.8338 18.1259 18.8338 16.2061C18.8338 14.1492 18.1827 12.1956 16.9509 10.5564C15.972 9.25335 14.6693 8.22182 13.1834 7.57313C12.3599 7.21292 11.4988 6.97598 10.6119 6.86421C12.4046 5.54447 13.0902 4.43836 13.0902 3.47362C13.0902 2.31592 12.1517 1.37744 10.994 1.37744C10.3649 1.37744 9.80107 1.65489 9.41686 2.09364C9.03265 1.65489 8.46873 1.37744 7.83972 1.37744C6.68202 1.37744 5.74354 2.31592 5.74354 3.47362C5.74354 4.43852 6.42931 5.54479 8.22272 6.86479C3.59204 7.45335 0 11.4181 0 16.2061C0 21.3985 4.22426 25.6228 9.41665 25.6228C10.1345 25.6228 10.8393 25.5431 11.5254 25.3861C10.5827 24.7628 9.73614 23.9955 9.02178 23.1109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5832 6.78955C16.8653 6.78955 16.1605 6.8692 15.4744 7.02618C16.4171 7.64954 17.2637 8.4168 17.9781 9.30143C21.6083 9.50683 24.4989 12.5251 24.4989 16.2062C24.4989 20.0198 21.3966 23.1224 17.5832 23.1224C15.8778 23.1224 14.2401 22.4966 12.9719 21.3603C11.5072 20.0503 10.667 18.1715 10.667 16.2062C10.667 14.558 11.2582 12.9708 12.3131 11.7285C11.5649 11.2437 10.706 10.9542 9.81083 10.8881C8.73347 12.4564 8.16602 14.2863 8.16602 16.2061C8.16602 18.263 8.81713 20.2166 10.049 21.8559C11.0278 23.1589 12.3305 24.1904 13.8164 24.8391C15.0055 25.3592 16.2727 25.6227 17.5832 25.6227C22.7756 25.6227 26.9998 21.3985 26.9998 16.2061C26.9998 11.0138 22.7755 6.78955 17.5832 6.78955Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_1052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.9fdd9f43b9125e2220ca858c956b0b0d.svg";
export { ForwardRef as ReactComponent };